import { Progress } from '@agro-club/agroclub-shared'
import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { useNotification } from 'hooks/useNotification'
import { User } from 'modules/domain/user/types'
import { UserContact } from 'modules/domain/userContact/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { CommonFields } from './CommonFields'

type Props = {
  setShowModal: () => void
  refetchContacts: () => void
  contact: UserContact
  user: User
}

type Fields = {
  full_name: string | null
  position: string | null
  phone: string | null
  is_mobile_phone: boolean
}

export const EditContactModal: FC<Props> = ({ setShowModal, user, refetchContacts, contact }) => {
  const { t } = useTranslation('userContact')
  const notify = useNotification()
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik<Fields>({
    initialValues: {
      full_name: contact.full_name,
      position: contact.position,
      phone: contact.phone,
      is_mobile_phone: contact.is_mobile_phone,
    },
    onSubmit: formHandler(
      async () => {
        await apiClient.put(endpoints.userContacts(user.id, contact.id), { ...formik.values })
      },
      {
        onSuccess: async () => {
          await refetchContacts()
          setShowModal()
          notify(Progress.SUCCESS, { title: t('edit_success') })
        },
        onError: (error) => {
          const { errors } = error
          formik.setErrors(errors)
        },
      },
    ),
  })

  return (
    <CommonFields
      id="EditContactModal"
      formik={formik}
      setShowModal={setShowModal}
      title={t('userContact:edit_contact')}
      progress={formProgress}
    />
  )
}
